import factory from '../requestFactory';
import store from '@/store'

export default ({service_id,pdf = null}) => {
    let params = {}
    if(pdf){
        params = {
            pdf:true,
            base_encode:true
        }
    }

    return factory()
        .get(`/time-table/prepare-info/${service_id}`, {params: params})

};
